import axios from 'axios';
import { config, baseUrl} from './config';

const prisUrl = baseUrl + '/prices/';

export const getAllPrices = async () => {
    const request = axios.get(baseUrl + '/prices/');
    try {
        const response = await request;
        return response.data;
    } catch (err) {
        console.log(err);
    }
}

// export const getPrice = async (id) => {
//     const request = axios.get(`${baseUrl}${id}`);
//     const response = await request;
//     return response.data;
// }

export const updatePrice = async (id, object) => {
    const request = axios.put(`${prisUrl}${id}`, object, config);
    try {
        const response = await request;
        return response.data;
    } catch (err) {
        console.log(err)
    }
}

export const createPrice = async (newObject) => {
    const request = axios.post(prisUrl, newObject, config);
    try {
        const response = await request;
        return response.data;
    } catch (err) {
        console.log(err);
    }
}

export const deletePris = async (id) => {
    try {
      const response = await axios.delete(`${prisUrl}${id}`, config);
      return response.data;
    } catch (err) {
      console.log(err);
    }
  };